import Zone from './Zone.vue'

export default Zone
